import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleBarChart } from '@carbon/charts-react';
import { useMenu } from 'src/hooks/useMenu';
import { useMenuItems } from 'src/hooks/useMenuItems';
import { useMoney } from 'src/hooks/useMoney';
import { useChartTheme } from './useChartTheme';

interface SalesByMenuProps {
  title: string;
  orderItemsSalesReports: any[];
  valueKey: string;
}

const ItemsSales = React.memo((props: SalesByMenuProps) => {
  const { t } = useTranslation('dashboard');
  const chartTheme = useChartTheme();
  const { format, formatCompact } = useMoney();
  const isMoneySeries = props.valueKey === 'totalSales';
  const { isLoading, data: menuItems } = useMenuItems();
  const { data: menu } = useMenu();
  const mappedMenuItems = menuItems?.data?.map((menuItem) => ({
    ...menuItem,
    menu: menu?.data?.find((r) => r.id === menuItem.menuId),
  }));
  return (
    <div className="dashboard__stat_widget">
      <SimpleBarChart
        data={
          isLoading
            ? []
            : props.orderItemsSalesReports.map((item) => {
                const menuItem = mappedMenuItems?.find((r) => r.id === item.menuItemId);
                return {
                  key: menuItem?.name,
                  group: menuItem?.menu?.name,
                  value: item[props.valueKey],
                };
              })
        }
        options={{
          title: props.title,
          axes: {
            left: {
              title: t('totalSales'),
              mapsTo: 'value',
              ticks: {
                formatter: (value) => (isMoneySeries ? formatCompact(value) : `${value}`),
              },
            },
            bottom: {
              title: t('menuItem'),
              mapsTo: 'key',
              scaleType: 'labels' as any,
            },
          },
          tooltip: { valueFormatter: (value) => (isMoneySeries ? format(value) : `${value}`) },
          height: '400px',
          theme: chartTheme,
        }}
      />
    </div>
  );
});

export default ItemsSales;
